import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getFixedQuantities } from './utils';

export const reception = [
  {
    id: 14,
    name: 'spaceTypes.reception.small',
    displayOrder: 1,
    spaceTypeId: spaceTypes.reception.id,
    size: {
      [countries.US]: getSize(15.0, 15.0),
      [countries.UK]: getSize(15.0, 15.0),
      [countries.FR]: getSize(4.572, 4.572),
      [countries.EU]: getSize(3.0, 5.0),
      [countries.DE]: getSize(3.0, 5.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818112/insite/qa/spaces/txjip6jqjvhp9od51lb5.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818112/insite/qa/spaces/txjip6jqjvhp9od51lb5.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818112/insite/qa/spaces/txjip6jqjvhp9od51lb5.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818112/insite/qa/spaces/txjip6jqjvhp9od51lb5.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818112/insite/qa/spaces/txjip6jqjvhp9od51lb5.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 15,
    name: 'spaceTypes.reception.medium',
    displayOrder: 2,
    spaceTypeId: spaceTypes.reception.id,
    size: {
      [countries.US]: getSize(20.0, 20.0),
      [countries.UK]: getSize(20.0, 20.0),
      [countries.FR]: getSize(6.096, 6.096),
      [countries.EU]: getSize(5.0, 5.0),
      [countries.DE]: getSize(5.0, 5.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(1),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(1),
      [countries.EU]: getFixedQuantities(1),
      [countries.DE]: getFixedQuantities(1),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818113/insite/qa/spaces/tsbple5gvriypfyom6g0.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818113/insite/qa/spaces/tsbple5gvriypfyom6g0.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818113/insite/qa/spaces/tsbple5gvriypfyom6g0.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818113/insite/qa/spaces/tsbple5gvriypfyom6g0.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818113/insite/qa/spaces/tsbple5gvriypfyom6g0.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 16,
    name: 'spaceTypes.reception.large',
    displayOrder: 3,
    spaceTypeId: spaceTypes.reception.id,
    size: {
      [countries.US]: getSize(25.0, 25.0),
      [countries.UK]: getSize(25.0, 25.0),
      [countries.FR]: getSize(7.62, 7.62),
      [countries.EU]: getSize(5.0, 8.0),
      [countries.DE]: getSize(5.0, 8.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818114/insite/qa/spaces/utci0igfboh53ktodkxd.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818114/insite/qa/spaces/utci0igfboh53ktodkxd.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818114/insite/qa/spaces/utci0igfboh53ktodkxd.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818114/insite/qa/spaces/utci0igfboh53ktodkxd.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818114/insite/qa/spaces/utci0igfboh53ktodkxd.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
